//FileDownoadStats
import React from 'react';

import { Box, LinearProgress, List, ListItem, ListItemText, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({

    colorFirstBar: {
        backgroundColor : '#e5e7eb',
    },
    colorSecondBar: {
        backgroundColor : '#fe752f ',
    },
    root : {
        maxWidth : '100%',
        marginLeft : '2vw',
        marginRight : '1vw',
        minHeight : '2vh'
    },
    text : {
        color : '#fefefe'
    },
    filename : {
        color : '#fefefe',
        marginLeft : '2vw',
        paddingBottom : '1vh',
        paddingTop : '1vh'      
    },
    list : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
    },
    deskText : {
        justifyContent : 'flex-start', padding : '0',
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    mobText : {
        justifyContent : 'flex-start', padding : '0',
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '20px !important',
        textAlign : 'center',
        fontWeight : '400 !important',
    },
    rootDesk : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '20px !important',
        textAlign : 'center',
        fontWeight : '400 !important',
    },
    rootMob : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '15px !important',
        fontWeight : '400 !important',
        textAlign : 'center',
    },


}));

export const FileDownloadStatsBar = function ({ view, fileName, value }) {

    const classes = useStyles();

    var handleFileName = () => {

        let files;
        if( fileName === ""){
            files = [];
        }else {
            files = fileName.split(',');
        }

        if ( view === 'mobile'){
            return files.map((file,idx)=> { 
                return(
                    <ListItem>
                        <ListItemText classes={{ primary : classes.rootMob }}  primary={ ( file.length ) > 30 ? (idx+1) + '. ' + file.slice(0,25) + '....' + file.slice(file.length-5,) : (idx+1) + '. ' + file } />
                    </ListItem>
                )
            })
        }else {
            return files.map((file,idx)=> { 
                return(
                    <ListItem>
                        <ListItemText classes={{ primary : classes.rootDesk }}  primary={ ( file.length ) > 60 ? (idx+1) + '. ' + file.slice(0,55) + '....' + file.slice(file.length-5,) : (idx+1) + '. ' + file } />
                    </ListItem>
                )
            })
        }

    }

    return(
        <div style={{ backgroundColor : ' #1c1c1c', width : '100%', height : '100%', display : 'grid', justifyItems : 'center' }} >
            <List>
                {handleFileName()}
            </List>
            <Box display="flex" alignItems="center" width="85%" >
                <Box width="100%" mr={1} >
                    <LinearProgress color="primary" variant="determinate" value={value} classes={{

                        colorPrimary : classes.colorFirstBar,
                        barColorPrimary : classes.colorSecondBar,
                        root : classes.root

                    }} />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" classes={{ root : classes.text }} >
                        {`${value}%`}
                    </Typography>
                </Box>
            </Box>
        </div>
    )

};